export const readableTextColor = hex => {
    const value = String(hex || "").replace("#", "");
    const full = value.length === 3 ? value.split("").map(char => char + char).join("") : value;
    if (full.length !== 6) return undefined;
    const [r, g, b] = [0, 2, 4].map(offset => parseInt(full.slice(offset, offset + 2), 16));
    if ([r, g, b].some(isNaN)) return undefined;
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? "#212529" : "#ffffff";
};

export const buildOptionColorMap = (options = []) =>
    (options || []).reduce((map, option) => {
        if (option?.value && option?.color) map[String(option.value).trim().toLowerCase()] = option.color;
        return map;
    }, {});

export const getOptionColor = (optionColors, value) => optionColors?.[String(value ?? "").trim().toLowerCase()];
